// extracted by mini-css-extract-plugin
module.exports = {"form":"form_form__necrY","button":"form_button__3qudf"};